import React, { useContext } from 'react';
const error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const defaultState = {
  addFlag: () => {
    // eslint-disable-next-line no-console
    console.error(error);
  },
  push: () => {
    // eslint-disable-next-line no-console
    console.error(error);
  },
  contextEntryPoint: null,
  cloudId: null
};
export const ProfileCardClientConfigContext = /*#__PURE__*/React.createContext(defaultState);
export const useProfileCardClientConfig = () => useContext(ProfileCardClientConfigContext);